import PropTypes from "prop-types";
import "./styles.css";

function isEmptyDeli(value) {
  if (value == null || value === false) return true;
  const text = String(value).trim();
  return !text || text === "false" || text === "true" || text === " - , " || text === "-";
}

function deliTone(label) {
  const text = String(label || "").trim();
  if (!text) return "";
  if (text === "Delivered" || /out for delivery/i.test(text)) return "ok";
  if (text === "Alert") return "danger";
  if (text === "Cancelled") return "";
  if (/pending|info received/i.test(text)) return "warn";
  return "transit";
}

function shortDeli(label) {
  const text = String(label || "").trim();
  if (/out for delivery/i.test(text)) return "Out for Delivery";
  return text;
}

function trackChipClass(tracking, cong) {
  const value = String(tracking || "");
  if (value.includes("refund")) return "tc-chip tc-chip--warn";
  if (value.includes("cancel")) return "tc-chip tc-chip--danger";
  if (cong) return "tc-chip";
  return "tc-chip tc-chip--info";
}

function canOpen17Track(tracking) {
  const value = String(tracking || "").trim();
  if (!value) return false;
  return !/^(cancel|refund)$/i.test(value) && !value.includes("cancel") && !value.includes("refund");
}

function seventeenTrackUrl(tracking) {
  return `https://t.17track.net/en#nums=${encodeURIComponent(String(tracking).trim())}`;
}

function statusTone(label) {
  const text = String(label || "").trim().toLowerCase();
  if (!text) return "";
  if (text === "delivered") return "ok";
  if (text === "shipped") return "transit";
  if (text === "processing") return "warn";
  if (text === "paid") return "info";
  if (text === "alert" || text === "undelivered" || text === "refunded") return "warn";
  if (text === "cancelled" || text === "error" || text === "fraudulent" || text.startsWith("case")) return "danger";
  return "info";
}

function TrackingCell({
  tracking,
  fulfil,
  deli,
  isDeli,
  status,
  cong,
  showFulfil,
  emptyTrack,
  onClick,
  onTrackClick,
  extra,
  trackExtra,
}) {
  const trackValue = String(tracking || "").trim();
  const deliLabel = isEmptyDeli(deli) ? "" : String(deli).trim();
  const isDeliLabel = isEmptyDeli(isDeli) ? "" : String(isDeli).trim();
  const showSecondDeli = Boolean(isDeliLabel && isDeliLabel !== deliLabel);
  const tone = deliTone(deliLabel);
  const statusLabel = String(status || "").trim();
  const statusChip = statusTone(statusLabel);

  return (
    <div className="tc-stack tracking-cell" onClick={onClick} style={onClick ? { cursor: "pointer" } : undefined}>
      {statusLabel ? (
        <div className="tc-row">
          <span className="tc-label">Status</span>
          <span className={`tc-chip${statusChip ? ` tc-chip--${statusChip}` : ""}`} title={statusLabel}>
            {statusLabel}
          </span>
        </div>
      ) : null}
      <div className="tc-row">
        <span className="tc-label">Track</span>
        {trackValue ? (
          <>
            <span
              className={trackChipClass(trackValue, cong)}
              title={trackValue}
              onClick={
                onTrackClick
                  ? (event) => {
                      event.stopPropagation();
                      onTrackClick(trackValue);
                    }
                  : undefined
              }
            >
              {trackValue}
            </span>
            {canOpen17Track(trackValue) ? (
              <a
                className="tc-icon-btn tracking-cell__17"
                href={seventeenTrackUrl(trackValue)}
                target="_blank"
                rel="noopener noreferrer"
                title="Open 17TRACK"
                onClick={(event) => event.stopPropagation()}
              >
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M14 5h5v5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M10 14 19 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  <path d="M18 13.2V18a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 4 18V7.5A1.5 1.5 0 0 1 5.5 6H10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </a>
            ) : null}
          </>
        ) : (
          <span className="tc-empty">{emptyTrack}</span>
        )}
        {trackExtra}
      </div>

      {showFulfil ? (
        <div className="tc-row">
          <span className="tc-label">Fulfil</span>
          {fulfil ? (
            <span className={String(fulfil).includes("A-") ? "tc-chip tc-chip--info" : "tc-chip tc-chip--warn"}>
              {fulfil}
            </span>
          ) : (
            <span className="tc-empty">Add</span>
          )}
        </div>
      ) : null}

      {deliLabel ? (
        <div className="tc-row">
          <span className="tc-label">Deli</span>
          <span className={`tc-chip tracking-cell__deli${tone ? ` tc-chip--${tone}` : ""}`} title={deliLabel}>
            {shortDeli(deliLabel)}
          </span>
        </div>
      ) : null}

      {showSecondDeli ? (
        <div className="tc-row">
          <span className="tc-label">Is Deli</span>
          <span className={`tc-chip tracking-cell__deli${deliTone(isDeliLabel) ? ` tc-chip--${deliTone(isDeliLabel)}` : ""}`} title={isDeliLabel}>
            {shortDeli(isDeliLabel)}
          </span>
        </div>
      ) : null}

      {extra}
    </div>
  );
}

TrackingCell.defaultProps = {
  tracking: "",
  fulfil: "",
  deli: "",
  isDeli: "",
  status: "",
  cong: false,
  showFulfil: false,
  emptyTrack: "Add",
  onClick: undefined,
  onTrackClick: undefined,
  extra: null,
  trackExtra: null,
};

TrackingCell.propTypes = {
  tracking: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  fulfil: PropTypes.string,
  deli: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isDeli: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  status: PropTypes.string,
  cong: PropTypes.bool,
  showFulfil: PropTypes.bool,
  emptyTrack: PropTypes.string,
  onClick: PropTypes.func,
  onTrackClick: PropTypes.func,
  extra: PropTypes.node,
  trackExtra: PropTypes.node,
};

export default TrackingCell;
